// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-5e0e1a74]{font-family:Vazir,serif!important;white-space:break-spaces;overflow:hidden;color:inherit!important}a[data-v-5e0e1a74]{color:hsla(0,0%,100%,.7)}", ""]);
// Exports
module.exports = exports;
